import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookAppPipe = (props: { messenger?: string } = {}) =>
  useQuery<crmModels.IFacebookAppPipe>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_APP_PIPE, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/crm/facebook/app-pipe',
          query: {
            messenger: props?.messenger
          }
        })
      );

      return res?.data?.data;
    }
  });
